import React, { useRef, useState, useEffect } from 'react';

const VideoPlayer: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [error, setError] = useState<string | null>(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleError = (e: Event) => {
      const videoElement = e.target as HTMLVideoElement;
      if (videoElement.error) {
        switch (videoElement.error.code) {
          case 1:
            setError('Video loading was aborted');
            break;
          case 2:
            setError('Network error - video not found or network issue');
            break;
          case 3:
            setError('Error decoding video');
            break;
          case 4:
            setError('Video format not supported');
            break;
          default:
            setError('Unknown error occurred');
        }
        console.error('Video error:', videoElement.error);
      }
    };

    video.addEventListener('error', handleError);
    return () => video.removeEventListener('error', handleError);
  }, []);

  return (
    <div 
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
        backgroundColor: '#000',
        borderRadius: '24px',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        transform: isHovered ? 'scale(1.02)' : 'scale(1)',
        boxShadow: isHovered 
          ? '0 30px 60px -15px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(124, 58, 237, 0.2), 0 0 60px rgba(124, 58, 237, 0.25)'
          : '0 25px 50px -12px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.1), 0 0 45px rgba(124, 58, 237, 0.15)'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {error ? (
        <div style={{
          color: 'white',
          padding: '20px',
          textAlign: 'center',
          backgroundColor: 'rgba(255, 0, 0, 0.2)',
          borderRadius: '8px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 0, 0, 0.3)'
        }}>
          <p style={{ margin: '0 0 10px 0', fontSize: '1.1rem', fontWeight: '500' }}>Error: {error}</p>
          <p style={{ margin: 0, fontSize: '0.9rem', opacity: 0.8 }}>Please check if the video file exists and is properly formatted.</p>
        </div>
      ) : (
        <>
          <video
            ref={videoRef}
            style={{
              width: '100%',
              height: '100%',
              display: 'block',
              objectFit: 'contain',
              borderRadius: '24px',
              transition: 'all 0.3s ease'
            }}
            controls
            playsInline
            preload="metadata"
          >
            <source src="/images/1.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(180deg, rgba(0,0,0,0.2) 0%, transparent 20%, transparent 80%, rgba(0,0,0,0.2) 100%)',
            pointerEvents: 'none',
            opacity: isHovered ? 1 : 0,
            transition: 'opacity 0.3s ease'
          }} />
        </>
      )}
    </div>
  );
};

export default VideoPlayer;